export const hasUnreadMessages = (message = {}) => {
  if (String(message?.estatusMensaje ?? message?.status ?? "") === "0") {
    return true;
  }

  const unreadCount = Number(
    message?.mensajesNoLeidos ?? message?.unreadCount ?? 0,
  );

  return Number.isFinite(unreadCount) && unreadCount >= 1;
};

export const hasUnreadChatReactionNotification = (notification = {}) =>
  Boolean(notification?.isChatReaction) && notification?.seen === false;
